import { render, staticRenderFns } from "./DocumentListItemMenu.vue?vue&type=template&id=198c5017&scoped=true&"
import script from "./DocumentListItemMenu.vue?vue&type=script&lang=js&"
export * from "./DocumentListItemMenu.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListItemMenu.vue?vue&type=style&index=0&id=198c5017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c5017",
  null
  
)

export default component.exports